export interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}

export type ExperimentMap = Record<string, ExperimentData>;
export type ExperimentData = Record<string, unknown>;

const HomepageBannerCTAValues = {
    control: 'search',
    base: 'city_browse',
};

export const HomepageBannerCTAExperiment: Experiment<
    typeof HomepageBannerCTAValues
> = {
    name: 'banner_cta_opens_search_screen',
    paramName: 'banner_cta_destination',
    values: HomepageBannerCTAValues,
};

/**
 * Leave the names of the enums/configs/etc static to keep imports from
 * needing to change as we iterate.
 *
 * Update the values to represent the new focus/paramname/goal of the test.
 * At the moment these correlate to the card map exported from DiscoverEventCard.
 */
export enum SearchCardFullClickExperimentValues {
    control = 'control',
    fullClick = 'fullClick',
}

export const SearchCardFullClickExperiment: Experiment<
    typeof SearchCardFullClickExperimentValues
> = {
    name: 'search_event_card_full_click_client',
    paramName: 'search_card_type',
    values: SearchCardFullClickExperimentValues,
};

export const SearchBoxAndLocationPillValues = {
    control: 'appears',
    base: 'does_not_appear',
};

// TODO: EB-225864 sticky experiment cleanup
export enum StickyExperimentValues {
    control = 'control',
    sticky = 'sticky',
}

export const StickyExperiment: Experiment<typeof StickyExperimentValues> = {
    name: 'sticky_header_nav',
    paramName: 'navigation_style',
    values: StickyExperimentValues,
};

export enum SubCategoryExperimentValues {
    control = 'control',
    subCategories = 'subcategories',
}

export const SubCategoryExperiment: Experiment<
    typeof SubCategoryExperimentValues
> = {
    name: 'search_subcategory_filters',
    paramName: 'category_type',
    values: SubCategoryExperimentValues,
};

export const HomepageSeasonalCarouselValues = {
    control: 'hide',
    test: 'show',
};

export const HomepageSeasonalCarouselExperiment: Experiment<
    typeof HomepageSeasonalCarouselValues
> = {
    name: 'mardi_gras_new_orleans',
    paramName: 'mardi_gras_carousel',
    values: HomepageSeasonalCarouselValues,
};

export const DatingInNightlifeValues = {
    control: 'hide',
    test: 'show',
};

export const DatingInNightlifeExperiment: Experiment<
    typeof DatingInNightlifeValues
> = {
    name: 'dating_tab_in_nightlife',
    paramName: 'dating_tab',
    values: DatingInNightlifeValues,
};
